import { jsPDF } from "jspdf";

export const generateChatReport = (messages, diagnosis, recommendedDoctors) => {
    const doc = new jsPDF();
    const lineHeight = 10;
    let y = 20;

    // Header
    doc.setFontSize(20);
    doc.setTextColor(49, 130, 206); // PulseNote Blue
    doc.text("PulseNote AI Health Report", 105, y, { align: "center" });
    y += 15;

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 105, y, { align: "center" });
    y += 20;

    // Diagnosis Section
    if (diagnosis) {
        doc.setFontSize(14);
        doc.setTextColor(0);
        doc.text("AI Analysis & Recommendation", 20, y);
        y += 10;

        doc.setFontSize(12);
        doc.setTextColor(40);
        doc.setFont("helvetica", "bold");
        const splitDiagnosis = doc.splitTextToSize(diagnosis, 170);
        doc.text(splitDiagnosis, 20, y);
        y += splitDiagnosis.length * 7 + 10;
    }

    // Symptoms / History Section
    doc.setFontSize(14);
    doc.setTextColor(0);
    doc.setFont("helvetica", "normal");
    doc.text("Consultation Summary", 20, y);
    y += 10;

    doc.setFontSize(10);
    messages.forEach((msg) => {
        if (y > 270) {
            doc.addPage();
            y = 20;
        }

        const prefix = msg.sender === 'user' ? "Patient: " : "AI: ";
        const text = prefix + msg.text.replace(/<br\/>/g, "\n").replace(/<strong>|<\/strong>/g, "");

        doc.setTextColor(msg.sender === 'user' ? 0 : 100);
        const splitText = doc.splitTextToSize(text, 170);
        doc.text(splitText, 20, y);
        y += splitText.length * 5 + 2;
    });

    y += 10;

    // Recommended Doctors
    if (recommendedDoctors && recommendedDoctors.length > 0) {
        if (y > 250) {
            doc.addPage();
            y = 20;
        }
        doc.setFontSize(14);
        doc.setTextColor(0);
        doc.text("Recommended Specialists Nearby", 20, y);
        y += 10;

        recommendedDoctors.forEach(docInfo => {
            doc.setFontSize(11);
            doc.setTextColor(0);
            doc.text(`• ${docInfo.name} (${docInfo.specialty})`, 25, y);
            doc.setFontSize(9);
            doc.setTextColor(100);
            doc.text(`  ${docInfo.location}`, 25, y + 5);
            y += 12;
        });
    }

    doc.save("PulseNote_Health_Report.pdf");
};
